import type {
  BannerUpdateObj,
  TvChannelUpdateObj,
  VodUpdateObj,
  TvShowUpdateObj,
} from '@setplex/tria-api'
import { MediaTypes, api } from '@setplex/tria-api'
import { createEvent, sample } from 'effector'

export const updateVod = createEvent<VodUpdateObj>()

export const updateTvShow = createEvent<TvShowUpdateObj>()

export const updateTvChannel = createEvent<TvChannelUpdateObj>()

export const updateBannerItem = createEvent<BannerUpdateObj>()

sample({
  clock: updateBannerItem,
  filter: ({ itemType }) => MediaTypes.VOD === itemType,
  fn: (params) => ({ ...params, favorite: Boolean(params.favorite) }),
  target: updateVod,
})

sample({
  clock: updateVod,
  fn: ({ favorite, id }) => ({ favorite: !favorite, id }),
  target: api.vods.updateVodFx,
})

sample({
  clock: updateBannerItem,
  filter: ({ itemType }) => MediaTypes.TV_SHOW === itemType,
  fn: (params) => ({ ...params, favorite: Boolean(params.favorite) }),
  target: updateTvShow,
})

sample({
  clock: updateTvShow,
  fn: ({ favorite, id }) => ({ favorite: !favorite, id }),
  target: api.tvshows.updateTvShowFx,
})

sample({
  clock: updateBannerItem,
  filter: ({ itemType }) => MediaTypes.TV_CHANNEL === itemType,
  fn: (params) => ({ ...params, favorite: Boolean(params.favorite) }),
  target: updateTvChannel,
})

sample({
  clock: updateTvChannel,
  fn: ({ favorite, id }) => ({ favorite: !favorite, id }),
  target: api.tv.updateTvChannelFx,
})
